(() => {
  const init = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const q = (s) => root.querySelector(s);
    const all = (s) => [...root.querySelectorAll(s)];
    const variants = JSON.parse(q('[data-reset-variants]').textContent);
    const lookup = (id) => variants.find(v => String(v.id) === String(id));
    const initial = lookup(root.dataset.selected);
    const money = (cents) => new Intl.NumberFormat(root.dataset.locale || 'en', {
      style: 'currency', currency: root.dataset.currency || 'USD'
    }).format(cents / 100);
    const route = window.Shopify?.routes?.root || '/';
    let quantity = 1, selected = [initial.id], active = 0, busy = false;
    const restored = history.state?.tenloveBackReset;
    if (restored?.productId === root.dataset.productId && restored.ids?.every(id => id === null || lookup(id)) && [1, 2].includes(restored.quantity)) {
      quantity = restored.quantity;
      selected = restored.ids.slice(0, quantity);
      active = Math.min(restored.active || 0, quantity - 1);
    }
    const error = (message = '') => {
      q('[data-error]').textContent = message;
      q('[data-error]').hidden = !message;
    };
    const counts = () => selected.reduce((map, id) => {
      if (id) map[id] = (map[id] || 0) + 1;
      return map;
    }, {});
    const allowed = () => selected.length === quantity && selected.every(Boolean) && Object.entries(counts()).every(([id, n]) => {
      const v = lookup(id);
      return v?.available && (!v.tracked || v.policy === 'continue' || v.stock >= n);
    });
    const price = () => selected.reduce((sum, id) => sum + (lookup(id)?.price || initial.price), 0);
    const subtotal = () => selected.reduce((sum, id) => {
      const cents = lookup(id)?.price || initial.price;
      return sum + (quantity === 2 ? cents - Math.floor(cents / 10) : cents);
    }, 0);
    const photo = (v) => v?.image || q('[data-gallery-slide="hero"] img').src;
    const update = () => {
      const valid = allowed(), total = subtotal(), count = counts();
      const current = lookup(selected[active]);
      all('[name="reset_bundle"]').forEach(input => {
        input.checked = Number(input.value) === quantity;
        input.closest('label').classList.toggle('is-selected', input.checked);
      });
      q('[data-slots]').hidden = quantity === 1;
      q('[data-select-help]').hidden = quantity === 1;
      q('[data-color-name]').textContent = current?.title || 'Choose stick 2';
      all('[data-slot]').forEach(button => {
        const slot = Number(button.dataset.slot), v = lookup(selected[slot]);
        button.setAttribute('aria-pressed', String(slot === active));
        const img = q(`[data-slot-img="${slot}"]`);
        img.hidden = !v;
        if (v) img.src = photo(v);
        q(`[data-slot-label="${slot}"]`).textContent = v?.title || 'Choose a color';
      });
      all('[data-color]').forEach(button => {
        const v = lookup(button.dataset.color), elsewhere = selected.filter((id, index) => index !== active && String(id) === String(v.id)).length;
        button.disabled = busy || !v.available || (v.tracked && v.policy !== 'continue' && v.stock <= elsewhere);
        button.setAttribute('aria-pressed', String(String(v.id) === String(selected[active])));
        const badge = button.querySelector('[data-color-count]');
        badge.hidden = quantity === 1 || !count[v.id];
        badge.textContent = count[v.id] > 1 ? '\u00d72' : '1';
        button.setAttribute('aria-label', `${v.title}${count[v.id] ? `, ${count[v.id]} selected` : ''}${button.disabled ? ', unavailable for this selection' : ''}`);
      });
      q('[data-each-price]').textContent = money(Math.round(total / quantity));
      q('[data-total]').textContent = money(total);
      q('[data-after-code]').textContent = money(total - Math.floor(total / 10));
      q('[data-after-code-note]').textContent = `${quantity === 1 ? 'for one' : 'for both'} with ${q('[data-copy-code]').dataset.copyCode}`;
      q('[data-primary-id]').value = selected[0] || initial.id;
      q('[data-primary-quantity]').value = quantity;
      const label = busy ? 'Adding...' : valid ? 'Buy Now' : selected.some(id => !id) ? 'Choose both colors' : 'Unavailable';
      q('[data-buy-label]').textContent = label;
      q('[data-buy]').disabled = busy || !valid;
      q('[data-add-cart]').disabled = busy || !valid;
      q('[data-sticky-buy]').disabled = busy || !valid;
      q('[data-sticky-buy]').textContent = busy ? 'Adding...' : 'Buy Now \u2192';
      q('[data-sticky-title]').textContent = quantity === 1 ? `Back Reset / ${lookup(selected[0])?.title || ''}` : '2 Back Reset sticks';
      q('[data-sticky-total]').textContent = money(total);
      const photos = q('[data-sticky-photos]');
      photos.replaceChildren(...selected.filter(Boolean).map(id => {
        const v = lookup(id), img = document.createElement('img');
        img.src = photo(v); img.alt = v.title; img.width = 45; img.height = 45;
        return img;
      }));
      const url = new URL(location.href);
      if (selected[0]) url.searchParams.set('variant', selected[0]);
      history.replaceState({...history.state, tenloveBackReset: {productId: root.dataset.productId, quantity, ids: selected, active}}, '', url);
    };
    all('[name="reset_bundle"]').forEach(input => input.addEventListener('change', () => {
      if (busy) return;
      quantity = Number(input.value);
      selected = quantity === 1 ? [selected[0]] : [selected[0], null];
      active = quantity - 1;
      error(); update();
    }));
    all('[data-slot]').forEach(button => button.addEventListener('click', () => {
      if (busy) return;
      active = Number(button.dataset.slot); update();
    }));
    const track = q('[data-gallery-track]'), slides = all('[data-gallery-slide]');
    let slide = 0;
    const go = (index) => {
      slide = Math.max(0, Math.min(slides.length - 1, index));
      track.scrollTo({left: slide * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    };
    const syncGallery = () => {
      slide = Math.round(track.scrollLeft / track.clientWidth);
      q('[data-gallery-count]').textContent = `${slide + 1} / ${slides.length}`;
      q('[data-photo-caption]').textContent = slides[slide]?.querySelector('img')?.alt.split(':')[0] || 'Back Reset';
      all('[data-thumb]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.thumb) === slide)));
    };
    track.addEventListener('scroll', syncGallery, {passive: true});
    track.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault(); go(slide + (event.key === 'ArrowRight' ? 1 : -1));
    });
    all('[data-thumb]').forEach(button => button.addEventListener('click', () => go(Number(button.dataset.thumb))));
    q('[data-gallery-prev]').addEventListener('click', () => go(slide - 1));
    q('[data-gallery-next]').addEventListener('click', () => go(slide + 1));
    all('[data-color]').forEach(button => button.addEventListener('click', () => {
      const v = lookup(button.dataset.color);
      if (busy || button.disabled) return;
      selected[active] = v.id;
      if (quantity === 2 && !selected[1 - active]) active = 1 - active;
      error(); update();
      go(slides.findIndex(s => s.dataset.gallerySlide === v.title.toLowerCase()));
    }));
    q('[data-copy-code]').addEventListener('click', async () => {
      const button = q('[data-copy-code]'), code = button.dataset.copyCode;
      try {
        await navigator.clipboard.writeText(code);
        button.textContent = 'Copied';
        q('[data-copy-status]').textContent = `${code} copied. Enter it at checkout.`;
      } catch (_) {
        button.textContent = code;
        q('[data-copy-status]').textContent = `Your code is ${code}. Enter it at checkout.`;
      }
    });
    const add = async (checkout) => {
      if (busy || !allowed()) return;
      busy = true; error(); q('[data-cart-status]').hidden = true; update();
      try {
        const response = await fetch(`${route}cart/add.js`, {
          method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({items: Object.entries(counts()).map(([id, n]) => ({id: Number(id), quantity: n}))})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Please check your selection and try again.');
        if (checkout) {
          location.assign(`${route}checkout`);
          return;
        }
        q('[data-cart-status]').hidden = false;
        const cartResponse = await fetch(`${route}cart.js`, {headers: {Accept: 'application/json'}});
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          document.dispatchEvent(new CustomEvent('cart:updated', {detail: cart}));
        }
      } catch (e) {
        error(e.message || 'We could not add this selection. Please try again.');
      }
      busy = false; update();
    };
    q('[data-reset-form]').addEventListener('submit', event => {
      event.preventDefault(); event.stopImmediatePropagation(); add(true);
    }, true);
    q('[data-add-cart]').addEventListener('click', () => add(false));
    q('[data-sticky-buy]').addEventListener('click', () => add(true));
    // Restore controls after the browser returns from hosted checkout via bfcache.
    window.addEventListener('pageshow', () => {busy = false; update();});
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      q('[data-reset-sticky]').hidden = entry.boundingClientRect.top >= 0;
    });
    observer.observe(q('[data-price-anchor]'));
    const dialog = q('[data-lightbox]');
    all('[data-enlarge]').forEach(button => button.addEventListener('click', () => {
      const image = button.querySelector('img');
      q('[data-lightbox-image]').src = image.src;
      q('[data-lightbox-image]').alt = image.alt;
      dialog.showModal();
    }));
    q('[data-close-lightbox]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {if (event.target === dialog) dialog.close();});
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) observer.disconnect();
    });
    update();
  };
  document.querySelectorAll('[data-back-reset]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-back-reset]').forEach(init));
})();

// Short silent clips. Native video controls remain as the no-JavaScript fallback.
(() => {
  const initMotion = (section) => {
    if (section.dataset.motionInitialized) return;
    section.dataset.motionInitialized = 'true';
    const preference = matchMedia('(prefers-reduced-motion: reduce)');
    const connection = navigator.connection;
    const cards = [...section.querySelectorAll('[data-motion-card]')];
    const records = cards.map(card => {
      const video = card.querySelector('video');
      const button = card.querySelector('[data-motion-toggle]');
      const record = { video, button, inView: false, wanted: !preference.matches && !connection?.saveData };
      video.muted = true;
      video.controls = false;
      button.hidden = false;
      const updateButton = () => {
        const verb = video.paused ? 'Play' : 'Pause';
        button.textContent = `${verb} clip`;
        button.setAttribute('aria-label', `${verb} ${video.dataset.motionName} clip`);
      };
      record.sync = () => {
        if (!record.wanted || !record.inView || document.hidden) {
          video.pause();
          updateButton();
          return;
        }
        const attempt = video.play();
        if (attempt) attempt.then(() => {
          if (!record.wanted || !record.inView || document.hidden) video.pause();
          updateButton();
        }).catch(updateButton);
      };
      button.addEventListener('click', () => {
        record.wanted = video.paused;
        record.sync();
      });
      video.addEventListener('play', updateButton);
      video.addEventListener('pause', updateButton);
      video.addEventListener('error', () => {
        record.wanted = false;
        button.textContent = 'Photo';
        button.setAttribute('aria-label', 'Video unavailable; product photo shown');
        button.disabled = true;
      });
      updateButton();
      return record;
    });
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const record = records.find(item => item.video === entry.target);
        if (!record) return;
        record.inView = entry.isIntersecting && entry.intersectionRatio >= 0.15;
        record.sync();
      });
    }, {threshold: [0, 0.15]});
    records.forEach(record => observer.observe(record.video));
    const visibility = () => records.forEach(record => record.sync());
    const stopForPreference = () => {
      if (preference.matches || connection?.saveData) records.forEach(record => {
        record.wanted = false;
        record.sync();
      });
    };
    preference.addEventListener('change', stopForPreference);
    connection?.addEventListener?.('change', stopForPreference);
    document.addEventListener('visibilitychange', visibility);
    const unload = event => {
      if (!event.target.contains(section)) return;
      observer.disconnect();
      records.forEach(record => record.video.pause());
      preference.removeEventListener('change', stopForPreference);
      connection?.removeEventListener?.('change', stopForPreference);
      document.removeEventListener('visibilitychange', visibility);
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
  };
  document.querySelectorAll('[data-reset-motion]').forEach(initMotion);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-reset-motion]').forEach(initMotion);
  });
})();
